<template>
<div id="app" class="contact-us page-template-default page wp-custom-logo wp-embed-responsive post-image-aligned-center sticky-menu-fade sticky-enabled both-sticky-menu no-sidebar nav-below-header separate-containers header-aligned-left dropdown-hover">
  <HeadNav selectedLanguage="en" page="contact" :gotodownload="gotodownload"
      :apk="apk"/>

  <div id="page" class="site grid-container container hfeed">
    <div id="content" class="site-content">
      <div id="primary" class="content-area">
        <main id="maincontent" class="site-main">
          <article class="page type-page status-publish">
            <div class="inside-article">
              <header class="entry-header section-content" aria-label="Content">
                <h1 class="entry-title" itemprop="headline">
                  Contact us
                </h1>
              </header>

              <div class="section-content" itemprop="text">
                <p>
                  Need assistance or have a question? We're here to help! You can reach out to us anytime at <strong>support@gb-dwnplus.com</strong> for inquiries, suggestions, or feedback and our dedicated team will be available round the clock to assist you with any queries or feedback you may have. We truly value your input and are eager to hear from you!
                </p>

                <form class="contact-form" @submit.prevent="handleSubmit">
                  <div class="form-group">
                    <label for="name">Name</label>
                    <input 
                      type="text" 
                      id="name" 
                      v-model="formData.name"
                      class="form-input"
                      placeholder="Enter your name"
                    />
                  </div>

                  <div class="form-group">
                    <label for="email">Email<span class="required">*</span></label>
                    <input 
                      type="email" 
                      id="email" 
                      v-model="formData.email"
                      class="form-input"
                      placeholder="Enter your email"
                      required
                    />
                  </div>

                  <div class="form-group">
                    <label for="message">Message<span class="required">*</span></label>
                    <textarea 
                      id="message" 
                      v-model="formData.message"
                      class="form-textarea"
                      rows="6"
                      placeholder="Enter your message"
                      required
                    ></textarea>
                  </div>

                  <div class="form-group">
                    <label for="email-confirm">Email</label>
                    <input 
                      type="email" 
                      id="email-confirm" 
                      v-model="formData.emailConfirm"
                      class="form-input"
                      placeholder="Confirm your email"
                    />
                  </div>

                  <div class="form-group">
                    <button type="submit" class="submit-btn">
                      Submit
                    </button>
                  </div>
                </form>
              </div>

              <div style="height: 20px" aria-hidden="true" class="wp-block-spacer" />
            </div>
          </article>
        </main>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import HeadNav from '@/components/HeadNav.vue';

export default {
  name: 'ContactUs',
  components: {
    HeadNav,
  },
  data() {
    return {
      pageName: 'contact',
      showapk: false,
      apk: null,
      from: 'gb',
      filename: 'gb',
      formData: {
        name: '',
        email: '',
        message: '',
        emailConfirm: '',
      },
    };
  },
  mounted() {
    this.from = this.$global.GetQueryString('from') || this.from;
    this.filename = this.$global.GetQueryString('filename') || this.filename;
    console.log(this.$global.GetQueryString('from'));
    if (this.$global.GetQueryString('from')) {
      this.getAPK();
    } else {
      this.getOfficalApk();
    }
  },
  methods: {
    handleSubmit() {
      // Handle form submission here
      console.log('Form submitted:', this.formData);
      // You can add API call here to send the form data
      alert('Thank you for your message! We will get back to you soon.');
      // Reset form
      this.formData = {
        name: '',
        email: '',
        message: '',
        emailConfirm: '',
      };
    },
    downloadfrom(reason) {
      this.download();
      this.$logEvent(`download_from_${reason}`, 'download');
    },
    getAPK() {
      this.$server
        .getAPPInfo({
          promotionChannel: this.from,
          promotionName: this.filename,
        })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            this.apk = res.data.apk;
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    getOfficalApk(type = 1, domain = null, appname = null) {
      this.$server
        .getOfficalApk({
          domain: domain || 'gbwhatsapp.chat',
          appName: appname || 'GB_gbwhatsapp.chat',
        })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            if (type == 1) {
              this.apk = res.data.apk;
            }
            this.lastupdate = res.data.promotion.updateTime;
            this.votes = res.data.promotion.totalCount;
            this.rating = res.data.promotion.score;
            console.log('apk getted');
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    gotodownload() {
      console.log(this.apk);
      if (this.apk) {
        this.$global.download(this.apk);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
h1 {
  font-size: 2.5rem;
  font-weight: bold;
  margin-bottom: 2rem;
  color: #333;
  position: relative;
  padding-left: 20px;
}

h1::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background: linear-gradient(to bottom, #25D366, #128C7E);
  border-radius: 2px;
}

h2 {
  font-size: 2rem;
  font-weight: bold;
  margin-top: 2rem;
  margin-bottom: 1.5rem;
  color: #333;
  position: relative;
  padding-left: 20px;
}

h2::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background: linear-gradient(to bottom, #25D366, #128C7E);
  border-radius: 2px;
}

h3 {
  font-size: 1.5rem;
  font-weight: bold;
  margin-top: 1.5rem;
  margin-bottom: 1rem;
  color: #333;
  position: relative;
  padding-left: 15px;
}

h3::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 3px;
  background: linear-gradient(to bottom, #25D366, #128C7E);
  border-radius: 2px;
}

.section-content {
  margin-top: 0;
  margin-bottom: 15px;
}

.section-content p {
  font-size: 1.1rem;
  line-height: 1.8;
  margin-bottom: 1.5rem;
  color: #555;
}

.contact-form {
  max-width: 600px;
  margin: 2rem 0;
  padding: 2rem;
  background: #f8f9fa;
  border-radius: 10px;
}

.form-group {
  margin-bottom: 1.5rem;
}

.form-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  color: #333;
  font-size: 1rem;
}

.required {
  color: #dc3545;
  margin-left: 3px;
}

.form-input,
.form-textarea {
  width: 100%;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 1rem;
  font-family: inherit;
  transition: border-color 0.3s ease;
  box-sizing: border-box;
}

.form-input:focus,
.form-textarea:focus {
  outline: none;
  border-color: #25D366;
  box-shadow: 0 0 0 3px rgba(37, 211, 102, 0.1);
}

.form-textarea {
  resize: vertical;
  min-height: 120px;
}

.submit-btn {
  background: #25D366;
  color: white;
  padding: 12px 30px;
  border: none;
  border-radius: 5px;
  font-size: 1.1rem;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
}

.submit-btn:hover {
  background: #128C7E;
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(37, 211, 102, 0.3);
}

.submit-btn:active {
  transform: translateY(0);
}

#maincontent {
  margin-top: 22px !important;
}

@media (max-width: 768px) {
  h1 {
    font-size: 2rem;
  }
  
  h2 {
    font-size: 1.5rem;
  }
  
  h3 {
    font-size: 1.2rem;
  }

  .contact-form {
    padding: 1.5rem;
  }
}
</style>

